<template>
    <item-form
            :model="model"
            :isEditing="false"
            @save-item="addItem">
    </item-form>
</template>

<script>
    import api from '../../api/soortbelichting';
    import ItemForm from './Form';

    export default {
        data () {
            return {
                warningModal: false,
                errormsg: '',
                model: {
                },
            };
        },
        methods: {
            addItem (model) {
                api.addSoortbelichting(model).then(() => {
                    this.$router.replace('/beheer/soortbelichting');
                },
                (error) => {
                    this.errormsg = error.message;
                    this.warningModal = true;
                });
            },
            closedialog () {
                this.warningModal = false;
            },
        },
        components: {
            'item-form': ItemForm,
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/soortbelichting/New.vue